import { createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import i18n from 'i18n'

import { ApplicationState } from '@/state/root.models'
import { RestApiService } from '@/services'
import {
  setLoadingFullAction,
  setSnackbarAction,
} from '@/state/ui/global/slices/index.slices'

import { BRAND } from './api.routes'
import { DeleteBrandsPayload } from '../models'
import ActionTypes from '../constants'

import { getAllBrandsThunk } from './get-all.thunk'

const restApiService: RestApiService = Container.get(RestApiService)

const deleteBrandThunk = createAsyncThunk(
  ActionTypes.DELETE_BRAND,
  async (payload: DeleteBrandsPayload, thunkAPI) => {
    try {
      restApiService.requestParams = {
        method: 'DELETE',
        endpoint: BRAND.BRANDS_DELETE,
        body: payload,
      }

      const { auth } = thunkAPI.getState() as ApplicationState

      thunkAPI.dispatch(setLoadingFullAction(true))

      const response: any = await restApiService.sendAuthData(auth.token)

      let message = i18n.t('messages.successfully', {
        item: `${i18n.t('brand')}`,
        what: i18n.t('labels.deleted'),
      })

      if (response.statusCode && response.statusCode !== 200) {
        message =
          typeof response.message === 'string'
            ? response.message
            : i18n.t('messages.errorOccurred')

        thunkAPI.dispatch(setLoadingFullAction(false))
      } else {
        thunkAPI.dispatch(getAllBrandsThunk({}))
      }

      thunkAPI.dispatch(
        setSnackbarAction({
          message,
          open: true,
          variant:
            response?.statusCode && response?.statusCode !== 200
              ? 'error'
              : 'success',
        }),
      )

      return response
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))
      throw error
    }
  },
)

export default deleteBrandThunk
